import { render, staticRenderFns } from "./BryntumTextAreaField.vue?vue&type=template&id=688e10cb"
import script from "./BryntumTextAreaField.vue?vue&type=script&lang=js"
export * from "./BryntumTextAreaField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports